import React from "react";
import Avatars from "../modules/Avatar";
import BasicTimeline from "../modules/TimeLine";

export default function QueryContent(props) {
  return (
    <div className="query-div">
     
      <BasicTimeline item={props.item} />
    </div>
  );
}
